/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadPlatformFeaturesQueryResponse, SocialExportGetUploadPlatformFeaturesPathParams, SocialExportGetUploadPlatformFeatures401, SocialExportGetUploadPlatformFeatures403, SocialExportGetUploadPlatformFeatures404 } from "../models/SocialExportGetUploadPlatformFeatures";

export function getSocialExportGetUploadPlatformFeaturesUrl(id: SocialExportGetUploadPlatformFeaturesPathParams["id"]) {
  const res = { method: 'GET', url: `/social-export/v1/upload/${id}/platform-features` as const }
  return res
}

/**
 * @description Returns which platform-specific actions are available for the upload based on connection capabilities and state.
 * @summary Get available platform features for an upload
 * {@link /social-export/v1/upload/:id/platform-features}
 */
export async function socialExportGetUploadPlatformFeatures(id: SocialExportGetUploadPlatformFeaturesPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<SocialExportGetUploadPlatformFeatures401 | SocialExportGetUploadPlatformFeatures403 | SocialExportGetUploadPlatformFeatures404>, unknown>({ method : "GET", url : getSocialExportGetUploadPlatformFeaturesUrl(id).url.toString(), ... requestConfig })
  return res.data
}